
export const HIGH = 'high'
export const MEDIUM = 'medium'
export const GOOD = 'good'



// WEBPACK FOOTER //
// ./src/lib/enums/alert.js